import PriceSelect from "components/common/PriceSelect";
import ProductSelect from "components/common/ProductSelect";
import { UnitPriceType } from "enums/UnitPriceType";
import QuoteProductGroup from "interfaces/QuoteProductGroup";
import QuoteSalesOrder from "interfaces/QuoteSalesOrder";
import * as numeral from "numeral";
import * as React from "react";
import { Option } from "react-select";
import MaskedInput from "react-text-mask";
import createNumberMask from "utils/createNumberMask";
import "./Step3.css";

interface QuoteProduct {
    productId?: number;
    uniqueAutoId?: number;
    unitMeasurement?: string;
    totalOrderedQuantity?: number;
    quantity: number;
    checked?: boolean;
    productName?: string;
    notes?: string;
    price: number;
    unitPriceTypeId?: number;
    unitPriceTypeName?: string;
    amount: number;
    cost: number;
    totalCost: number;
}
interface Props {
    onSubmit: Function;
    onCancel: Function;
    isDraft: boolean;
    data: QuoteSalesOrder;
}

interface State {
    productGroups: QuoteProductGroup<EditableQuoteProduct>[];
    initialProductGroups: any;
    subTotal: number;
    subTotalCost: number;
    salesTax: number;
    grandTotal: number;
    data: QuoteSalesOrder;
    editingProductId?: number | undefined;
    checked?: boolean;
}

interface EditableQuoteProduct extends QuoteProduct {
    isEditing: boolean;
}

export default class SalesOrderStep2 extends React.Component<Props, State> {
    private categoryNameInputs: HTMLTextAreaElement[];
    private unitPriceTypeNames: string[];

    public constructor(props: Props) {
        super(props);

        this.unitPriceTypeNames = ["", "TBD", "NC", "Not Avail", "No Bid", "Note"];

        this.state = {
            productGroups: [],
            initialProductGroups: [],
            subTotal: 0,
            salesTax: 0,
            grandTotal: 0,
            subTotalCost: 0,
            data: this.props.data,
        };

        this.categoryNameInputs = [];

        this.handleHeaderNameChanged = this.handleHeaderNameChanged.bind(this);
        this.handleAddCategoryClicked = this.handleAddCategoryClicked.bind(this);
        this.handleAddProduct = this.handleAddProduct.bind(this);
        this.handleEditProductClicked = this.handleEditProductClicked.bind(this);
        this.handleRemoveProduct = this.handleRemoveProduct.bind(this);
        this.handleRemoveHeader = this.handleRemoveHeader.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleSubmitAsDraft = this.handleSubmitAsDraft.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.handleDragEnd = this.handleDragEnd.bind(this);
        this.doNothing = this.doNothing.bind(this);
    }

    public render() {
        return (
            <div>
                <div className="tab-bar mb-4 pb-3">
                    <p className="tab-bar__step-info text-right">Step 2 of 3</p>

                    <ul className="tab-bar__list">
                        <li className="">
                            <a href="#" onClick={(event) => this.handleSubmit(event, 1)}>
                                Sales Order Details
                            </a>
                        </li>
                        <li className="active">
                            <a href="#" onClick={(event) => this.handleSubmit(event, 2)}>
                                Material Details
                            </a>
                        </li>
                        {this.props.data.shippingMethod === "direct" && (
                            <li className="">
                                <button
                                    style={{ background: "none", border: "none" }}
                                    disabled={
                                        this.state.productGroups.reduce(
                                            (acc: any, current: any) => {
                                                current.products.reduce(
                                                    (productAcc: any, productCurrent: any) => {
                                                        if (
                                                            productCurrent.checked &&
                                                            productCurrent.productId !== null
                                                        ) {
                                                            acc.push({
                                                                ...productCurrent,
                                                            });
                                                        }
                                                    },
                                                    []
                                                );
                                                return acc;
                                            },
                                            []
                                        ).length === 0
                                    }
                                    onClick={(event) => this.handleSubmit(event, 3)}
                                >
                                    Vendor Details
                                </button>
                            </li>
                        )}
                    </ul>
                </div>
                <div className="card card--form">
                    <div className="card-block mb-8">
                        <form>
                            <h2 className="card__title">Material Details</h2>
                            {this.state.productGroups.map((item, groupIndex) => (
                                <div key={groupIndex}>
                                    <div className="row">
                                        <div
                                            className="col-sm-12 quote-product-header"
                                        >
                                            <textarea
                                                name={`categoryName[${groupIndex}]`}
                                                className="form-control"
                                                placeholder="Header Name"
                                                value={item.name}
                                                onChange={this.handleHeaderNameChanged}
                                                ref={(x) =>
                                                    (this.categoryNameInputs[groupIndex] = x!)
                                                }
                                                data-index={groupIndex}
                                                readOnly
                                            />
                                        </div>
                                    </div>
                                    <table className="table table-responsive tblQuote mt-2">
                                        <thead>
                                            <tr>
                                                <th style={{ width: "2%" }}>
                                                    <input
                                                        name="check[]"
                                                        onChange={(e: any) => {
                                                            const productGroups =
                                                                this.state.productGroups.reduce(
                                                                    (acc: any, current: any) => {
                                                                        acc.push({
                                                                            ...current,
                                                                            products: current.products.reduce(
                                                                                (
                                                                                    productAcc: any,
                                                                                    productCurrent: any
                                                                                ) => {
                                                                                    productAcc.push({
                                                                                        ...productCurrent,
                                                                                        ...(productCurrent.productId
                                                                                            ? {
                                                                                                checked:
                                                                                                    e.target.checked,
                                                                                            }
                                                                                            : {}),
                                                                                    });
                                                                                    return productAcc;
                                                                                },
                                                                                []
                                                                            ),
                                                                        });
                                                                        return acc;
                                                                    },
                                                                    []
                                                                );
                                                            productGroups.map(
                                                                (product: string, index: string) => {
                                                                    const productGroupsChecked =
                                                                        productGroups[
                                                                            index
                                                                        ].products.filter(
                                                                            (val: any) => val.checked
                                                                        );
                                                                    productGroups[index].subTotal =
                                                                        productGroupsChecked.reduce(
                                                                            (total: any, product: any) =>
                                                                                total + product.amount,
                                                                            0
                                                                        );
                                                                    productGroups[index].subTotalCost =
                                                                        productGroupsChecked.reduce(
                                                                            (total: any, product: any) =>
                                                                                total + product.totalCost,
                                                                            0
                                                                        );
                                                                }
                                                            );

                                                            const subTotal = productGroups.reduce(
                                                                (total: any, category: any) =>
                                                                    total + category.subTotal,
                                                                0
                                                            );
                                                            const subTotalCost = productGroups.reduce(
                                                                (total: any, category: any) =>
                                                                    total + category.subTotalCost,
                                                                0
                                                            );
                                                            const salesTax =
                                                                this.props.data.salesTaxRate != null
                                                                    ? subTotal *
                                                                    this.props.data.salesTaxRate!
                                                                    : 0;
                                                            const grandTotal = subTotal + salesTax;

                                                            this.setState({
                                                                productGroups,
                                                                subTotal,
                                                                subTotalCost,
                                                                salesTax,
                                                                grandTotal,
                                                            });
                                                        }}
                                                        type="checkbox"
                                                    />
                                                </th>
                                                <th style={{ width: "8%" }}>Quantity</th>
                                                <th style={{ width: "8%" }}>
                                                    Total Ordered Quantity
                                                </th>
                                                <th style={{ width: "5%" }}>UM</th>
                                                <th style={{ width: "30%" }}>Item</th>
                                                <th style={{ width: "15%" }}>Notes</th>
                                                <th style={{ width: "8%" }}>Price Type</th>
                                                <th style={{ width: "8%" }}>Price</th>
                                                <th style={{ width: "8%" }}>Amount</th>
                                                <th style={{ width: "10%" }}></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {item.products.map((item, productIndex) => (
                                                item.isEditing ? (
                                                    <tr
                                                        key={
                                                            groupIndex + "," + productIndex
                                                        }
                                                        className="sortable-table-row quote-edit-product-row"
                                                    >
                                                        <EditProductRow
                                                            data={item}
                                                            onSubmit={(e: any) =>
                                                                this.handleEditProduct(
                                                                    e,
                                                                    groupIndex,
                                                                    productIndex
                                                                )
                                                            }
                                                        />
                                                    </tr>
                                                ) : (
                                                    <tr
                                                        key={
                                                            groupIndex + "," + productIndex
                                                        }
                                                        className={`sortable-table-row ${item.price === 0 ? "disabled-row" : ""}`}
                                                    >
                                                        <td style={{ width: "10%" }}>
                                                            <input
                                                                name="check[]"
                                                                checked={item.checked}
                                                                type="checkbox"
                                                                disabled={!item.productId}
                                                                onChange={(e) => {
                                                                    //const productGroups =
                                                                    //    this.state.productGroups.reduce(
                                                                    //        (
                                                                    //            acc: any,
                                                                    //            current: any
                                                                    //        ) => {
                                                                    //            acc.push({
                                                                    //                ...current,
                                                                    //                products:
                                                                    //                    current.products.reduce(
                                                                    //                        (
                                                                    //                            productAcc: any,
                                                                    //                            productCurrent: any
                                                                    //                        ) => {
                                                                    //                            productAcc.push(
                                                                    //                                {
                                                                    //                                    ...productCurrent,
                                                                    //                                    ...(productCurrent.uniqueAutoId ===
                                                                    //                                        item.uniqueAutoId
                                                                    //                                        ? {
                                                                    //                                            checked:
                                                                    //                                                e
                                                                    //                                                    .target
                                                                    //                                                    .checked,
                                                                    //                                        }
                                                                    //                                        : {}),
                                                                    //                                }
                                                                    //                            );
                                                                    //                            return productAcc;
                                                                    //                        },
                                                                    //                        []
                                                                    //                    ),
                                                                    //            });
                                                                    //            return acc;
                                                                    //        },

                                                                    //        []
                                                                    //    );

                                                                    //const productGroupsChecked =
                                                                    //    productGroups[
                                                                    //        groupIndex
                                                                    //    ].products.filter(
                                                                    //        (val: any) => val.checked
                                                                    //    );
                                                                    //productGroups[
                                                                    //    groupIndex
                                                                    //].subTotal =
                                                                    //    productGroupsChecked.reduce(
                                                                    //        (
                                                                    //            total: any,
                                                                    //            product: any
                                                                    //        ) =>
                                                                    //            total + product.amount,
                                                                    //        0
                                                                    //    );
                                                                    //productGroups[
                                                                    //    groupIndex
                                                                    //].subTotalCost =
                                                                    //    productGroupsChecked.reduce(
                                                                    //        (
                                                                    //            total: any,
                                                                    //            product: any
                                                                    //        ) =>
                                                                    //            total +
                                                                    //            product.totalCost,
                                                                    //        0
                                                                    //    );
                                                                    //productGroups[
                                                                    //    groupIndex
                                                                    //].grandTotal =
                                                                    //    productGroupsChecked.reduce(
                                                                    //        (
                                                                    //            total: any,
                                                                    //            product: any
                                                                    //        ) =>
                                                                    //            total + product.amount,
                                                                    //        0
                                                                    //    );

                                                                    //const subTotal =
                                                                    //    productGroupsChecked.reduce(
                                                                    //        (
                                                                    //            total: any,
                                                                    //            category: any
                                                                    //        ) =>
                                                                    //            total +
                                                                    //            category.subTotal,
                                                                    //        0
                                                                    //    );
                                                                    //const subTotalCost =
                                                                    //    productGroupsChecked.reduce(
                                                                    //        (
                                                                    //            total: any,
                                                                    //            category: any
                                                                    //        ) =>
                                                                    //            total +
                                                                    //            category.subTotalCost,
                                                                    //        0
                                                                    //    );
                                                                    //const salesTax =
                                                                    //    this.props.data
                                                                    //        .salesTaxRate != null
                                                                    //        ? subTotal *
                                                                    //        this.props.data
                                                                    //            .salesTaxRate!
                                                                    //        : 0;
                                                                    //const grandTotal =
                                                                    //    subTotal + salesTax;
                                                                    //this.setState({
                                                                    //    productGroups,
                                                                    //    subTotal,
                                                                    //    subTotalCost,
                                                                    //    salesTax,
                                                                    //    grandTotal,
                                                                    //});

                                                                    const productGroups = this.state.productGroups.map((group, gIndex) => {
                                                                        if (gIndex === groupIndex) {
                                                                            return {
                                                                                ...group,
                                                                                products: group.products.map((product, pIndex) => {
                                                                                    if (pIndex === productIndex) {
                                                                                        return {
                                                                                            ...product,
                                                                                            checked: e.target.checked,
                                                                                        };
                                                                                    }
                                                                                    return product;
                                                                                }),
                                                                            };
                                                                        }
                                                                        return group;
                                                                    });

                                                                    const productGroupsChecked =
                                                                        productGroups[groupIndex].products.filter(
                                                                            (val: any) => val.checked
                                                                        );

                                                                    productGroups[groupIndex].subTotal =
                                                                        productGroupsChecked.reduce(
                                                                            (
                                                                                total: any,
                                                                                product: any
                                                                            ) =>
                                                                                total + product.amount,
                                                                            0
                                                                        );

                                                                    productGroups[groupIndex].subTotalCost =
                                                                        productGroupsChecked.reduce(
                                                                            (
                                                                                total: any,
                                                                                product: any
                                                                            ) =>
                                                                                total +
                                                                                product.totalCost,
                                                                            0
                                                                        );

                                                                    //productGroups[groupIndex].grandTotal =
                                                                    //    productGroupsChecked.reduce(
                                                                    //        (
                                                                    //            total: any,
                                                                    //            product: any
                                                                    //        ) =>
                                                                    //            total + product.amount,
                                                                    //        0
                                                                    //    );

                                                                    const subTotal =
                                                                        productGroupsChecked.reduce(
                                                                            (
                                                                                total: any,
                                                                                category: any
                                                                            ) =>
                                                                                total +
                                                                                category.subTotal,
                                                                            0
                                                                        );
                                                                    const subTotalCost =
                                                                        productGroupsChecked.reduce(
                                                                            (
                                                                                total: any,
                                                                                category: any
                                                                            ) =>
                                                                                total +
                                                                                category.subTotalCost,
                                                                            0
                                                                        );
                                                                    const salesTax =
                                                                        this.props.data
                                                                            .salesTaxRate != null
                                                                            ? subTotal *
                                                                            this.props.data
                                                                                .salesTaxRate!
                                                                            : 0;

                                                                    const grandTotal = subTotal + salesTax;

                                                                    this.setState({
                                                                        productGroups,
                                                                        subTotal,
                                                                        subTotalCost,
                                                                        salesTax,
                                                                        grandTotal,
                                                                    });
                                                                }}
                                                            />
                                                        </td>
                                                        <td style={{ width: "10%" }}>
                                                            {item.quantity}
                                                        </td>
                                                        <td style={{ width: "20%" }}>
                                                            {item.totalOrderedQuantity}
                                                        </td>
                                                        <td style={{ width: "5%" }}>
                                                            {item.unitMeasurement}
                                                        </td>
                                                        <td style={{ width: "30%" }}>
                                                            {item.productName}
                                                        </td>
                                                        <td style={{ width: "10%" }}>
                                                            {item.notes}
                                                        </td>
                                                        <td style={{ width: "8%" }}>
                                                            {item.unitPriceTypeId &&
                                                                this.unitPriceTypeNames[
                                                                item.unitPriceTypeId
                                                                ]}
                                                        </td>
                                                        <td
                                                            className="text-right"
                                                            style={{ width: "8%" }}
                                                        >
                                                            {numeral(item.price).format(
                                                                "$0,0.00"
                                                            )}
                                                        </td>
                                                        <td
                                                            className="text-right"
                                                            style={{ width: "8%" }}
                                                        >
                                                            {numeral(item.amount).format(
                                                                "$0,0.00"
                                                            )}
                                                        </td>
                                                        <td
                                                            className="text-center"
                                                            style={{ width: "10%" }}
                                                        >
                                                            <a
                                                                href="#"
                                                                className="btn-edit"
                                                                onClick={(event) =>
                                                                    this.handleEditProductClicked(
                                                                        event,
                                                                        groupIndex,
                                                                        productIndex,
                                                                        item.uniqueAutoId,
                                                                        item.checked
                                                                    )
                                                                }
                                                            >
                                                                <i className="icon-edit1"></i>
                                                            </a>
                                                        </td>
                                                    </tr>
                                                )

                                            ))}
                                        </tbody>

                                        <tfoot>
                                            <tr className="sub-total">
                                                <td colSpan={7}>Subtotal</td>
                                                <td colSpan={2} className="text-right">
                                                    {numeral(item.subTotal).format("$0,0.00")}
                                                </td>
                                            </tr>
                                        </tfoot>
                                    </table>
                                </div>
                            ))}

                            <div className="text-center">
                                <button
                                    className="btn-link"
                                    onClick={(event) => this.handleSubmit(event, 1)}
                                >
                                    Previous
                                </button>
                                {this.state.data.shippingMethod === "direct" && (
                                    <button
                                        className="btn btn-primary"
                                        onClick={(event) => this.handleSubmit(event, 3)}
                                        disabled={
                                            this.state.productGroups.reduce(
                                                (acc: any, current: any) => {
                                                    current.products.reduce(
                                                        (productAcc: any, productCurrent: any) => {
                                                            if (
                                                                productCurrent.checked &&
                                                                productCurrent.productId !== null
                                                            ) {
                                                                acc.push({
                                                                    ...productCurrent,
                                                                });
                                                            }
                                                        },
                                                        []
                                                    );
                                                    return acc;
                                                },
                                                []
                                            ).length === 0
                                        }
                                    >
                                        Next(Add Vendor)
                                    </button>
                                )}
                                {this.state.data.shippingMethod === "yard" ||
                                    this.state.data.shippingMethod === undefined ? (
                                    <div className="business-button-holder">
                                        <button
                                            className="btn btn-primary"
                                            onClick={(event) => this.handleSubmit(event, 4)}
                                            disabled={
                                                this.state.productGroups.reduce(
                                                    (acc: any, current: any) => {
                                                        current.products.reduce(
                                                            (productAcc: any, productCurrent: any) => {
                                                                if (
                                                                    productCurrent.checked &&
                                                                    productCurrent.productId !== null
                                                                ) {
                                                                    acc.push({
                                                                        ...productCurrent,
                                                                    });
                                                                }
                                                            },
                                                            []
                                                        );
                                                        return acc;
                                                    },
                                                    []
                                                ).length === 0
                                            }
                                        >
                                            Preview
                                        </button>
                                        <span>
                                            Note: The quote will also be saved as a Sales Order once
                                            sent to business Central
                                        </span>
                                    </div>
                                ) : (
                                    ""
                                )}
                                <button className="btn-link" onClick={this.handleCancel}>
                                    Cancel
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        );
    }

    public componentDidMount() {

        let subTotal: number = 0;
        let salesTax: number = 0;
        let grandTotal: number = 0;
        let subTotalCost: number = 0;
        let categories: any = [];
        if (this.props.data.costGroups !== undefined) {
            categories = this.props.data.costGroups as any;
        } else {
            categories = this.props.data
                .productGroups as QuoteProductGroup<EditableQuoteProduct>[];

            if (categories.length === 0) {
                categories.push({
                    name: "",
                    products: [],
                    subTotal: 0,
                });
                subTotalCost = 0;
                subTotal = 0;
                salesTax = 0;
                grandTotal = 0;
            } else {
                categories.map((product: any, index: any) => {
                    const productGroupsChecked = categories[index].products.filter(
                        (val: any) => val.checked
                    );
                    categories[index].subTotal = productGroupsChecked.reduce(
                        (total: any, product: any) => total + product.amount,
                        0
                    );
                    categories[index].subTotalCost = productGroupsChecked.reduce(
                        (total: any, product: any) => total + product.totalCost,
                        0
                    );
                });
                subTotalCost = 0;
                subTotal = 0;
                salesTax = 0;
                grandTotal = 0;
            }
        }

        this.setState({
            initialProductGroups: categories,
            productGroups: categories,
            subTotal: subTotal,
            salesTax: salesTax,
            grandTotal: 0,
            subTotalCost: subTotalCost,
        });
    }

    public componentDidUpdate() {
        for (var i = 0; i < this.state.productGroups.length; i++) {
            this.categoryNameInputs[i].style.height = "0px";
            this.categoryNameInputs[i].style.height =
                this.categoryNameInputs[i].scrollHeight + "px";
        }
    }

    private doNothing(e: React.FormEvent<HTMLAnchorElement>) {
        e.preventDefault();
    }

    private handleSubmit(
        event: React.MouseEvent<HTMLButtonElement> | any,
        nextStepNumber: number
    ) {
        event.preventDefault();

        const categories = this.state.productGroups;

        let data = {
            categories,
            nextStepNumber: nextStepNumber,
        };

        this.props.onSubmit(data);
    }

    private handleSubmitAsDraft(event: React.MouseEvent<HTMLButtonElement>) {
        event.preventDefault();

        let data = {
            categories: this.state.productGroups,
            saveAsDraft: true,
        };

        for (let i = 0; i < this.categoryNameInputs.length; i++) {
            data.categories[i].name = this.categoryNameInputs[i].value;
        }

        this.props.onSubmit(data);
    }

    private handleCancel(event: React.MouseEvent<HTMLButtonElement>) {
        event.preventDefault();

        this.props.onCancel();
    }

    private handleAddCategoryClicked() {
        let categories = this.state.productGroups;
        categories.push({
            name: "",
            products: [],
            subTotal: 0,
            subTotalCost: 0,
        });
        this.setState({
            productGroups: categories,
        });
    }

    private handleAddProduct(data: EditableQuoteProduct, groupIndex: number) {
        data.isEditing = false;
        let categories = this.state.productGroups;

        categories[groupIndex].subTotal = categories[groupIndex].products.reduce(
            (total, product) => total + product.amount,
            0
        );
        categories[groupIndex].subTotalCost = categories[
            groupIndex
        ].products.reduce((total, product) => total + product.totalCost, 0);
        let subTotal = categories.reduce(
            (total, category) => total + category.subTotal,
            0
        );
        let subTotalCost = categories.reduce(
            (total, category) => total + category.subTotal,
            0
        );

        let salesTax =
            this.props.data.salesTaxRate !== undefined
                ? subTotal * this.props.data.salesTaxRate!
                : 0;
        let grandTotal = subTotal + salesTax;
        this.setState({
            productGroups: categories,
            subTotal: subTotal,
            subTotalCost: subTotalCost,
            salesTax: salesTax,
            grandTotal: grandTotal,
        });
    }

    private handleEditProductClicked(
        e: React.SyntheticEvent<HTMLAnchorElement>,
        groupIndex: number,
        productIndex: number,
        id: number | undefined,
        isChecked: boolean | undefined
    ) {
        e.preventDefault();

        let categories = this.state.productGroups;
        categories[groupIndex].products[productIndex].isEditing = true;

        this.setState({
            productGroups: categories,
            editingProductId: id,
            checked: isChecked
        });
    }

    private handleEditProduct(
        data: EditableQuoteProduct,
        groupIndex: number,
        productIndex: number
    ) {
        data.isEditing = false;
        data.uniqueAutoId = this.state.editingProductId;
        data.checked = this.state.checked;

        let categories = this.state.productGroups;
        categories[groupIndex].products[productIndex] = data;
        categories[groupIndex].subTotal = categories[groupIndex].products.reduce(
            (total, product) => total + product.amount,
            0
        );
        categories[groupIndex].subTotalCost = categories[
            groupIndex
        ].products.reduce((total, product) => total + product.totalCost, 0);
        categories.map((product: any, index: any) => {
            const productGroupsChecked = categories[index].products.filter(
                (val: any) => val.checked
            );
            categories[index].subTotal = productGroupsChecked.reduce(
                (total: any, product: any) => total + product.amount,
                0
            );
            categories[index].subTotalCost = productGroupsChecked.reduce(
                (total: any, product: any) => total + product.totalCost,
                0
            );
        });
        let subTotal = categories.reduce(
            (total, category) => total + category.subTotal,
            0
        );
        let subTotalCost = categories.reduce(
            (total, category) => total + category.subTotal,
            0
        );
        let salesTax =
            this.props.data.salesTaxRate !== undefined
                ? subTotal * this.props.data.salesTaxRate!
                : 0;
        let grandTotal = subTotal + salesTax;
        this.setState({
            productGroups: categories,
            subTotal: subTotal,
            subTotalCost: subTotalCost,
            salesTax: salesTax,
            grandTotal: grandTotal,
        });
    }

    private handleRemoveProduct(
        e: React.SyntheticEvent<HTMLAnchorElement>,
        groupIndex: number,
        productIndex: number
    ) {
        e.preventDefault();

        let categories = this.state.productGroups;
        categories[groupIndex].products.splice(productIndex, 1);
        categories[groupIndex].subTotal = categories[groupIndex].products.reduce(
            (total, product) => total + product.amount,
            0
        );
        let subTotal = categories.reduce(
            (total, category) => total + category.subTotal,
            0
        );
        let salesTax =
            this.props.data.salesTaxRate !== undefined
                ? subTotal * this.props.data.salesTaxRate!
                : 0;
        let grandTotal = subTotal + salesTax;
        this.setState({
            productGroups: categories,
            subTotal: subTotal,
            salesTax: salesTax,
            grandTotal: grandTotal,
        });
    }

    private handleHeaderNameChanged(event: React.FormEvent<HTMLTextAreaElement>) {
        this.state.productGroups[
            parseInt(event.currentTarget.dataset.index!, 10)
        ].name = event.currentTarget.value;
        this.setState({
            productGroups: this.state.productGroups,
        });

        event.currentTarget.style.height = "0px";
        event.currentTarget.style.height = event.currentTarget.scrollHeight + "px";
    }

    private handleRemoveHeader(
        e: React.SyntheticEvent<HTMLAnchorElement>,
        groupIndex: number
    ) {
        e.preventDefault();

        const productGroups = this.state.productGroups;
        productGroups.splice(groupIndex, 1);
        this.categoryNameInputs.splice(groupIndex, 1);

        let subTotal: number;
        let salesTax: number;
        let grandTotal: number;

        if (productGroups.length === 0) {
            productGroups.push({
                name: "",
                products: [],
                subTotal: 0,
            });

            subTotal = 0;
            salesTax = 0;
            grandTotal = 0;
        } else {
            subTotal = productGroups.reduce(
                (total, group) => total + group.subTotal,
                0
            );
            salesTax =
                this.props.data.salesTaxRate !== undefined
                    ? subTotal * this.props.data.salesTaxRate!
                    : 0;
            grandTotal = subTotal + salesTax;
        }

        this.setState({
            productGroups: productGroups,
            subTotal: subTotal,
            salesTax: salesTax,
            grandTotal: grandTotal,
        });
    }

    private handleDragEnd(result: any, provided: any) {
        if (!result.destination) {
            return;
        }

        if (result.draggableId.indexOf("header-") === 0) {
            if (result.source.droppableId === result.destination.droppableId) {
                return;
            }

            const sourceGroupIndex = parseInt(result.source.droppableId, 10);
            const destinationGroupIndex = parseInt(
                result.destination.droppableId,
                10
            );
            const productGroups = this.reorder(
                this.state.productGroups,
                sourceGroupIndex,
                destinationGroupIndex
            );
            this.setState({
                productGroups: productGroups,
            });
        } else if (result.draggableId.indexOf("product-") === 0) {
            if (result.source.droppableId === result.destination.droppableId) {
                // Reordering within the same list
                const groupIndex = parseInt(result.source.droppableId, 10);
                const products = this.reorder(
                    this.state.productGroups[groupIndex].products,
                    result.source.index,
                    result.destination.index
                );
                this.state.productGroups[groupIndex].products = products;
                this.setState({
                    productGroups: this.state.productGroups,
                });
            } else {
                // Item is being moved to a different list
                const sourceGroupIndex = parseInt(result.source.droppableId, 10);
                const destinationGroupIndex = parseInt(
                    result.destination.droppableId,
                    10
                );
                const newArrays = this.move(
                    this.state.productGroups[sourceGroupIndex].products,
                    result.source.index,
                    this.state.productGroups[destinationGroupIndex].products,
                    result.destination.index
                );

                this.state.productGroups[sourceGroupIndex].products = newArrays.source;
                this.state.productGroups[sourceGroupIndex].subTotal =
                    newArrays.source.reduce(
                        (total, product) => total + product.amount,
                        0
                    );
                this.state.productGroups[destinationGroupIndex].products =
                    newArrays.destination;
                this.state.productGroups[destinationGroupIndex].subTotal =
                    newArrays.destination.reduce(
                        (total, product) => total + product.amount,
                        0
                    );

                this.setState({
                    productGroups: this.state.productGroups,
                });
            }
        }
    }

    private reorder<T>(list: T[], startIndex: number, endIndex: number) {
        const result = Array.from(list);
        const [removed] = result.splice(startIndex, 1);
        result.splice(endIndex, 0, removed);

        return result;
    }

    private move<T>(
        source: T[],
        sourceIndex: number,
        destination: T[],
        destinationIndex: number
    ) {
        const sourceClone = Array.from(source);
        const destClone = Array.from(destination);
        const [removed] = sourceClone.splice(sourceIndex, 1);

        destClone.splice(destinationIndex, 0, removed);

        return {
            source: sourceClone,
            destination: destClone,
        };
    }
}

interface AddProductRowProps {
    onSubmit: Function;
}

interface AddProductRowState extends QuoteProduct {
    maskedQuantity: string;
    maskedPrice: string;
}

class AddProductRow extends React.Component<
    AddProductRowProps,
    AddProductRowState
> {
    private quantityInputRef: React.RefObject<HTMLInputElement>;
    private productSelectRef: React.RefObject<ProductSelect>;
    private notesInputRef: React.RefObject<HTMLTextAreaElement>;
    private unitPriceTypeSelectRef: React.RefObject<HTMLSelectElement>;
    private priceSelectRef: React.RefObject<PriceSelect>;

    public constructor(props: AddProductRowProps) {
        super(props);

        this.state = {
            maskedQuantity: "",
            quantity: 0,
            unitMeasurement: "",
            productName: "",
            price: 0,
            maskedPrice: "",
            amount: 0,
            productId: -1,
            cost: 0,
            totalCost: 0,
            totalOrderedQuantity: 0,
        };

        this.quantityInputRef = React.createRef();
        this.productSelectRef = React.createRef();
        this.notesInputRef = React.createRef();
        this.unitPriceTypeSelectRef = React.createRef();
        this.priceSelectRef = React.createRef();

        this.handleInputChanged = this.handleInputChanged.bind(this);
        this.handleQuantityChanged = this.handleQuantityChanged.bind(this);
        this.handleProductSelect = this.handleProductSelect.bind(this);
        this.handlePriceTypeChanged = this.handlePriceTypeChanged.bind(this);
        this.handlePriceChanged = this.handlePriceChanged.bind(this);
        this.handleQuantityOrPriceChanged =
            this.handleQuantityOrPriceChanged.bind(this);
        this.handleNotesChanged = this.handleNotesChanged.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    public render() {
        const numberMask = createNumberMask({
            allowDecimal: true,
            allowZeroFractionPadding: true,
        });

        return (
            <>
                <td>
                    <input
                        type="number"
                        step="any"
                        name="quantity"
                        className="form-control"
                        onChange={this.handleQuantityChanged}
                        value={this.state.maskedQuantity}
                        ref={this.quantityInputRef}
                    />
                </td>
                <td>
                    <input
                        type="text"
                        name="unitMeasurement"
                        className="form-control"
                        onChange={this.handleInputChanged}
                        value={this.state.unitMeasurement}
                    />
                </td>
                <td>
                    <ProductSelect
                        onItemSelect={this.handleProductSelect}
                        ref={this.productSelectRef}
                    />
                </td>
                <td>
                    <textarea
                        name="notes"
                        className="form-control"
                        onChange={this.handleNotesChanged}
                        value={this.state.notes}
                        ref={this.notesInputRef}
                    />
                </td>
                <td>
                    <select
                        className="form-control"
                        onChange={this.handlePriceTypeChanged}
                        value={this.state.unitPriceTypeId}
                        ref={this.unitPriceTypeSelectRef}
                    >
                        <option value="">--</option>
                        <option value={UnitPriceType.TBD}>TBD</option>
                        <option value={UnitPriceType.NC}>NC</option>
                        <option value={UnitPriceType.NotAvail}>Not Avail</option>
                        <option value={UnitPriceType.NoBid}>No Bid</option>
                        <option value={UnitPriceType.NotMade}>Not Made</option>
                        <option value={UnitPriceType.Note}>Note</option>
                    </select>
                </td>
                <td>
                    <PriceSelect
                        productId={this.state.productId}
                        ref={this.priceSelectRef}
                        onItemSelect={this.handlePriceChanged}
                        onInputChange={this.handlePriceChanged}
                    />
                </td>
                <td className="text-right">
                    {this.state.amount !== undefined &&
                        numeral(this.state.amount).format("$0,0.00")}
                </td>
                <td>
                    <button
                        type="button"
                        className="form-control btn btn-primary"
                        onClick={this.handleSubmit}
                    >
                        Add
                    </button>
                </td>
            </>
        );
    }

    private handleInputChanged(
        event: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>
    ) {
        this.setState({
            [event.currentTarget.name]: event.currentTarget.value,
        } as any);
    }

    private handleQuantityChanged(event: React.FormEvent<HTMLInputElement>) {
        const maskedValue = event.currentTarget.value;
        const value = parseFloat(maskedValue) || 0;

        this.setState({
            quantity: value,
            maskedQuantity: maskedValue,
        });

        this.handleQuantityOrPriceChanged();
    }

    private handlePriceTypeChanged(event: React.FormEvent<HTMLSelectElement>) {
        var unitPriceTypeId = parseInt(event.currentTarget.value, 10) || undefined;

        this.setState({
            unitPriceTypeId: unitPriceTypeId,
        });
    }

    private handlePriceChanged(inputPrice: string) {
        const value = parseFloat(inputPrice) || 0;

        this.setState({
            price: value,
        });

        this.handleQuantityOrPriceChanged();
    }

    private handleQuantityOrPriceChanged() {
        this.setState((prevState) => ({
            amount: prevState.quantity * prevState.price,
        }));
    }

    private async handleProductSelect(value: Option | null) {
        if (value === null) {
            this.setState({
                productId: undefined,
                unitMeasurement: undefined,
                productName: undefined,
            });
        } else {
            this.setState({
                productId: value!.value as number,
                unitMeasurement: value!.unitMeasurement as string | undefined,
                productName: value!.label as string,
            });
        }
    }

    private handleNotesChanged(event: React.FormEvent<HTMLTextAreaElement>) {
        this.handleInputChanged(event);
        event.currentTarget.style.height = "0px";
        event.currentTarget.style.height = event.currentTarget.scrollHeight + "px";
    }

    private handleSubmit() {
        let data = {
            productId: this.state.productId,
            quantity: this.state.quantity,
            unitMeasurement: this.state.unitMeasurement,
            productName: this.state.productName,
            notes: this.state.notes,
            unitPriceTypeId: this.state.unitPriceTypeId,
            price: this.state.price,
            amount: this.state.amount,
            cost: this.state.cost,
            totalCost: this.state.totalCost,
        };

        this.props.onSubmit(data);

        this.productSelectRef.current!.value = undefined;
        this.notesInputRef.current!.value = "";
        this.unitPriceTypeSelectRef.current!.value = "";

        this.setState({
            productId: undefined,
            maskedQuantity: "",
            quantity: 0,
            unitMeasurement: "",
            productName: "",
            notes: undefined,
            unitPriceTypeId: undefined,
            price: 0,
            maskedPrice: "",
            amount: 0,
        });

        this.notesInputRef.current!.style.height = "0px";
        this.notesInputRef.current!.style.height =
            this.notesInputRef.current!.scrollHeight + "px";

        (this.quantityInputRef.current! as any).focus();
    }
}

interface EditProductRowProps {
    data: EditableQuoteProduct;
    onSubmit: Function;
}

class EditProductRow extends React.Component<
    EditProductRowProps,
    AddProductRowState
> {
    private quantityInputRef: React.RefObject<HTMLInputElement>;
    private productSelectRef: React.RefObject<ProductSelect>;
    private notesInputRef: React.RefObject<HTMLTextAreaElement>;
    private priceInputRef: React.RefObject<MaskedInput>;
    private priceSelectRef: React.RefObject<PriceSelect>;

    public constructor(props: EditProductRowProps) {
        super(props);

        this.state = {
            productId: props.data.productId,
            maskedQuantity: props.data.quantity.toString(),
            quantity: props.data.quantity,
            unitMeasurement: props.data.unitMeasurement,
            productName: props.data.productName,
            notes: props.data.notes,
            price: props.data.price,
            unitPriceTypeId: props.data.unitPriceTypeId,
            maskedPrice: props.data.price.toString(),
            amount: props.data.amount,
            cost: props.data.cost,
            totalCost: props.data.totalCost,
            totalOrderedQuantity: props.data.totalOrderedQuantity,
            checked: props.data.checked
        };

        this.quantityInputRef = React.createRef();
        this.productSelectRef = React.createRef();
        this.notesInputRef = React.createRef();
        this.priceInputRef = React.createRef();
        this.priceSelectRef = React.createRef();

        this.handleInputChanged = this.handleInputChanged.bind(this);
        this.handleQuantityChanged = this.handleQuantityChanged.bind(this);
        this.handleProductSelect = this.handleProductSelect.bind(this);
        this.handlePriceChanged = this.handlePriceChanged.bind(this);
        this.handleQuantityOrPriceChanged =
            this.handleQuantityOrPriceChanged.bind(this);
        this.handleNotesChanged = this.handleNotesChanged.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    public render() {
        const numberMask = createNumberMask({
            allowDecimal: true,
            allowZeroFractionPadding: true,
        });

        return (
            <>
                <td style={{ width: "10%" }}>
                    <input name="check[]" type="checkbox" checked={this.state.checked}
                        disabled></input>
                </td>
                <td>
                    <input
                        type="number"
                        step="any"
                        name="quantity"
                        className="form-control"
                        onChange={this.handleQuantityChanged}
                        value={this.state.maskedQuantity}
                    />
                </td>
                <td>{this.state.totalOrderedQuantity}</td>
                <td>{this.state.unitMeasurement}</td>
                <td>{this.state.productName}</td>
                <td>{this.state.notes}</td>
                <td>{this.state.unitPriceTypeName}</td>
                <td>{this.state.price}</td>
                <td className="text-right">
                    {this.state.amount !== undefined &&
                        numeral(this.state.amount).format("$0,0.00")}
                </td>
                <td>
                    <button
                        type="button"
                        className="form-control btn btn-primary"
                        onClick={this.handleSubmit}
                    >
                        Update
                    </button>
                </td>
            </>
        );
    }

    private handleInputChanged(
        event: React.FormEvent<
            HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement
        >
    ) {
        this.setState({
            [event.currentTarget.name]: event.currentTarget.value,
        } as any);
    }

    private handleQuantityChanged(event: React.FormEvent<HTMLInputElement>) {
        const maskedValue = event.currentTarget.value;
        const value = parseFloat(maskedValue) || 0;

        this.setState({
            quantity: value,
            maskedQuantity: maskedValue,
        });

        this.handleQuantityOrPriceChanged();
    }

    private handlePriceChanged(inputPrice: string) {
        const value = parseFloat(inputPrice) || 0;

        this.setState({
            price: value,
        });

        this.handleQuantityOrPriceChanged();
    }

    private handleQuantityOrPriceChanged() {
        this.setState((prevState) => ({
            amount: prevState.quantity * prevState.price,
        }));
    }

    private async handleProductSelect(value: Option | null) {
        if (value === null) {
            this.setState({
                productId: undefined,
                unitMeasurement: undefined,
                productName: undefined,
                uniqueAutoId: undefined,
            });
        } else {
            this.setState({
                uniqueAutoId: value!.value as number,
                productId: value!.value as number,
                unitMeasurement: value!.unitMeasurement as string | undefined,
                productName: value!.label as string,
            });
        }
    }

    private handleNotesChanged(event: React.FormEvent<HTMLTextAreaElement>) {
        this.handleInputChanged(event);
        event.currentTarget.style.height = "0px";
        event.currentTarget.style.height = event.currentTarget.scrollHeight + "px";
    }

    private handleSubmit() {
        let data = {
            productId: this.state.productId,
            quantity: this.state.quantity,
            unitMeasurement: this.state.unitMeasurement,
            productName: this.state.productName,
            notes: this.state.notes,
            unitPriceTypeId: this.state.unitPriceTypeId,
            price: this.state.price,
            amount: this.state.amount,
            cost: this.state.cost,
            totalCost: this.state.totalCost,
            uniqueAutoId: this.state.uniqueAutoId,
            /*checked: this.state.checked,*/
            totalOrderedQuantity: this.state.totalOrderedQuantity,
        };

        this.props.onSubmit(data);
    }
}



// WEBPACK FOOTER //
// ./ClientApp/components/quotes/SalesOrderStep2.tsx